

function addProductSelectionToCart() {
  
  if (productSelection.length > 0) {
    const addToCart = document.getElementById('product-add-to-cart');
    
    addToCart.addEventListener('click', function() {
      alert("hello")
    })
  }
}

// document.querySelector('.product-selection__wrapper').addEventListener('click', function(event) {
//   const productSelection = event.querySelectorAll('.product-selection__wrapper .product');

//   if (productSelection) {
//     console.log(productSelection)
//     for (let index = 0; index < productSelection.length; index++) {
//       const element = productSelection[index];
//       element.addEventListener('click', function() {
//       })
//     }
//   }
// })

//$(document).on('click.addToCart', '[data-btn-addtocart]', function() {
//  console.log("hello")
//  
//});